import React, { Fragment, useEffect, useState } from "react";
import {
  Col,
  Row,
  Form,
  Card,
  Input,
  Button,
  CardHeader,
  Table,
  CardBody,
  Spinner,
} from "reactstrap";
import { formatRP } from "../../../Utils/externalFunctions";
import KonfirmasiStepDua from "./KonfirmasiStepDua";
import { useThemeContext } from "../../../Context/ThemeContext";
import { getDarkTableRow } from "../../../Utils/otherFunctions";

const StepDua = ({
  prevStep,
  nextStep,
  handleChange,
  formRealokasi,
  setFormRealokasi,
  selectedRencImp,
  formattedNilai,
  formType,
}) => {
  const [konfirmasiModalOpen, setKonfirmasiModalOpen] = useState(false);
  const toggleRealokasiModal = () =>
    setKonfirmasiModalOpen(!konfirmasiModalOpen);
  const handleKonfirmasiRealokasi = () => {
    toggleRealokasiModal();
  };

  const { themeContext } = useThemeContext();

  useEffect(() => {
    selectedRencImp &&
      setFormRealokasi((prev) => ({
        ...prev,
        kd_rencana_implementasi: selectedRencImp.pk,
        kd_anggaran_bulanan_unit_kerja:
          selectedRencImp.id_anggaran_bulanan_unit_kerja,
        kd_akun: selectedRencImp.kd_akun,
        nm_akun: selectedRencImp.nm_akun,
        kd_keg: selectedRencImp.kd_keg,
        nm_keg: selectedRencImp.nm_keg,
        kode_jk: selectedRencImp.kode_jk,
        nama_jk: selectedRencImp.nama_jk,
        unit_kerja: selectedRencImp.nm_org,
      }));
  }, [selectedRencImp]);

  const setIsTarget = (isTarget) => {
    setFormRealokasi((prev) => ({
      ...prev,
      is_target: isTarget,
    }));
  };

  let isFormComplete =
    formRealokasi.nilai_anggaran &&
    formRealokasi.alasan &&
    formRealokasi.keterangan;

  let isValidValue =
    parseInt(selectedRencImp?.anggaran_tersisa) -
      formRealokasi.nilai_anggaran >=
    0;

  return (
    <Fragment>
      <Row>
        <Col sm="12">
          <Form className="needs-validation">
            <Card>
              <Row className="justify-content-md-center">
                <Col md="4">
                  <CardHeader className="pb-3 text-center mt-4">
                    <h2>
                      <strong>Form Realokasi</strong>
                    </h2>
                  </CardHeader>
                  {selectedRencImp ? (
                    <Table hover>
                      <tbody>
                        <tr>
                          <td
                            className={
                              "align-center" + getDarkTableRow(themeContext)
                            }
                          >
                            <strong>DPSJ</strong>
                          </td>
                          <td className={getDarkTableRow(themeContext)}>
                            {selectedRencImp.nm_org}
                          </td>
                        </tr>
                        <tr>
                          <td className={getDarkTableRow(themeContext)}>
                            <strong>Kegiatan</strong>
                          </td>
                          <td className={getDarkTableRow(themeContext)}>
                            <p>
                              {selectedRencImp.kd_keg} -{" "}
                              {selectedRencImp.nm_keg}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td className={getDarkTableRow(themeContext)}>
                            <strong>Akun</strong>
                          </td>
                          <td className={getDarkTableRow(themeContext)}>
                            <p>
                              {selectedRencImp.kd_akun} -{" "}
                              {selectedRencImp.nm_akun}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td className={getDarkTableRow(themeContext)}>
                            <strong>Sisa Anggaran</strong>
                          </td>
                          <td className={getDarkTableRow(themeContext)}>
                            <p>
                              Rp. {formatRP(selectedRencImp.anggaran_tersisa)}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td className={getDarkTableRow(themeContext)}>
                            <strong>Anggaran Realokasi</strong>
                          </td>
                          <td className={getDarkTableRow(themeContext)}>
                            <Input
                              className="form-control"
                              name="nilai_anggaran"
                              type="text"
                              placeholder="Masukkan Nilai Realokasi"
                              onChange={handleChange}
                              value={formattedNilai}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className={getDarkTableRow(themeContext)}>
                            <strong>Keterangan</strong>
                          </td>
                          <td className={getDarkTableRow(themeContext)}>
                            <Input
                              className="form-control"
                              name="keterangan"
                              type="textarea"
                              placeholder="Masukkan Keterangan"
                              defaultValue={formRealokasi.keterangan}
                              onChange={handleChange}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className={getDarkTableRow(themeContext)}>
                            <strong>Alasan</strong>
                          </td>
                          <td className={getDarkTableRow(themeContext)}>
                            <Input
                              className="form-control"
                              name="alasan"
                              type="textarea"
                              placeholder="Masukkan Alasan"
                              defaultValue={formRealokasi.alasan}
                              onChange={handleChange}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  ) : (
                    <div className="d-flex justify-content-center p-4">
                      <Spinner />
                    </div>
                  )}
                </Col>
              </Row>

              <CardBody>
                <Row>
                  <Col className="d-flex justify-content-between">
                    <Button
                      color="primary"
                      variant="contained"
                      disabled={!isFormComplete}
                      onClick={() =>
                        handleKonfirmasiRealokasi() & setIsTarget("f")
                      }
                    >
                      Tambahkan Sumber Ini dan Kurangi Dari
                    </Button>
                    <Button
                      color="primary"
                      variant="contained"
                      disabled={!isFormComplete || !isValidValue}
                      onClick={() =>
                        handleKonfirmasiRealokasi() & setIsTarget("t")
                      }
                    >
                      Kurangi Sumber Ini dan Tambahkan Ke
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            {formType === "create" ? (
              <div className="row justify-content-between m-4">
                <div className="col-auto">
                  <Button onClick={() => prevStep()}>Kembali</Button>
                </div>
              </div>
            ) : null}
          </Form>
        </Col>
      </Row>
      {formRealokasi.is_target && (
        <KonfirmasiStepDua
          konfirmasiModalOpen={konfirmasiModalOpen}
          toggleRealokasiModal={toggleRealokasiModal}
          nextStep={nextStep}
          formRealokasi={formRealokasi}
        />
      )}
    </Fragment>
  );
};
export default StepDua;
